module.exports = __webpack_public_path__ + "img/story17-4.jpeg";